// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"2b7a3836","142":"b21a1db3","150":"a6fcbb8c","185":"a5857729","210":"6850a241","314":"0f635ac8","389":"37da18f3","528":"dc0d0be0","571":"8622f6f1","912":"37da18f3","954":"bcf58084"}[chunkId] + ".chunk.css";
};